<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Consulta de Liquidaciones de Venta</h3>
            </div>
            <div class="layout__controls">
                <div class="form-inline">
                    <button @click="consultar" class="btn-info btn--bigger">
                        <i class="fa fa-search"></i><span>Consultar</span>
                    </button>
                    <button @click="exportar" class="btn-success btn--bigger">
                        <i class="fa fa-file-excel-o"></i><span>Exportar</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card__title">
                <h5>Información de la consulta</h5>
            </div>
            <div class="card__content">
                <div class="row">
                    <div class="col-xs-12 col-md-4">
                        <div class="form-field select2" :class="{
                        'select2--disabled': bodegas.length == 1
                        }">
                            <div class="select2-field">
                                <v-select @input="inputBodega" v-model="selectedBodega" :options="bodegas" label="descripcion" placeholder="Seleccione..."></v-select>
                                <label for="bodegas">Sucursal</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-4">
                        <div class="form-field select2">
                            <div class="select2-field">
                                <v-select
                                placeholder="Seleccione..."
                                id="vendedor_id"
                                v-model="selectedVendedor"
                                :options="vendedores"
                                @input="inputVendedor"
                                @search="searchVendedores"
                                label="descripcion"
                                ></v-select>
                                <label for="vendedor_id">Vendedor</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-4">
                        <div class="form-field select">
                            <div class="select-field">
                                <select name="tipo_fecha" id="tipo_fecha" v-model="form.tipo_fecha">
                                    <option value="H">Hoy</option>
                                    <option value="A">Ayer</option>
                                    <option value="P">Personalizada</option>
                                </select>
                                <label for="fecha">Fecha</label>
                            </div>
                        </div>
                    </div>
                    <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
                        <div class="form-field">
                            <div class="datepicker-field">
                                <VueCtkDateTimePicker
                                id="desde"
                                v-model="form.desde"
                                locale="es"
                                only-date
                                no-label
                                button-now-translation="Ahora"
                                format="YYYY-MM-DD"
                                formatted="YYYY-MM-DD"
                                label="Seleccione fecha..."
                                />
                                <label>Desde</label>
                            </div>
                        </div>
                    </div>
                    <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
                        <div class="form-field">
                            <div class="datepicker-field">
                                <VueCtkDateTimePicker
                                id="hasta"
                                v-model="form.hasta"
                                locale="es"
                                only-date
                                no-label
                                button-now-translation="Ahora"
                                format="YYYY-MM-DD"
                                formatted="YYYY-MM-DD"
                                label="Seleccione fecha..."
                                />
                                <label>Hasta</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card__title">
                <h5>Resultados de la Consulta</h5>
            </div>
            <div class="card__content">
                <div class="row">
                    <div class="col-xs-12">
                        <k-table
                            @pagar="pagar"
                            @referir="referir"
                            :buttons="buttons"
                            @anular="anular"
                            @imprimirExcel="imprimirExcel"
                            @imprimir="imprimir"
                            :buscarButton="false"
                            :filterStatus="false"
                            :deleteButton="false"
                            :createButton="false"
                            :editButton="false"
                            :params="form"
                            ref="roles"
                            :path="path"
                            :columns="[
                            {
                                    display: 'Sucursal',
                                    value: 'bodega.descripcion',
                                },
                                {
                                    display: 'Número de documento',
                                    value: 'numero_documento',
                                },
                                {
                                    display: 'Vendedor',
                                    value: 'supervisor.descripcion',
                                },
                                {
                                    display: 'Fecha de liquidación',
                                    value: 'fecha_liquidacion',
                                },
                                {
                                    display: 'Nuevas',
                                    value: 'ventas_nuevas',
                                },
                                {
                                    display: 'Pendientes',
                                    value: 'ventas_pendientes',
                                },
                                {
                                    display: 'Ventas totales',
                                    value: 'ventas_totales',
                                },
                                {
                                    display: 'Canceladas',
                                    value: 'canceladas',
                                },
                                {
                                    display: 'Total de comisiones',
                                    value: 'total_comisiones',
                                    numeric: false
                                },
                                {
                                    display: 'Total de descuentos',
                                    value: 'total_gastos',
                                    numeric: false
                                },
                                {
                                    display: 'Liquido a recibir',
                                    value: 'liquido_recibir',
                                    numeric: false
                                }
                            ]"
                        ></k-table>
                    </div>
                </div>
            </div>
        </div>
        <modal height="auto" width="70%" name="referirTarjetas" scrollable reset adaptive resizable>
            <referir-tarjetas @cerrar="$modal.hide('referirTarjetas')" :valor_referido="valor_referido" :liquidacionId="selectedLiquidacionId" :supervisor_id="selectedVendedorId"></referir-tarjetas>
        </modal>
    </div>
</template>

<script>
import ReferirTarjetas from './ReferirTarjetas.vue';
export default {
    components: {
        ReferirTarjetas
    },
    data: function () {
        return {
            buttons: [],
            form: {
                tipo_fecha: 'H',
                desde: moment(new Date()).format('YYYY-MM-DD'),
                hasta: moment(new Date()).format('YYYY-MM-DD'),
                tipo: 'T',
                vendedor_id:  '',
                bodega_id: '',
                tipo_consulta: 'N'
            },
            selectedVendedor: null,
            selectedBodega: null,
            path: url + '/consulta-liquidaciones-venta',
            vendedores: [],
            selectedLiquidacionId: '',
            selectedVendedorId: ''
        };
    },
    props: {
        referir_tarjetas_liquidacion: {
            type: Boolean,
            required: false,
            default: false
        },
        anular_liquidacion_venta: {
            type: Boolean,
            required: false,
            default: false
        },
        bodegas: {
            type: Array,
            required: false,
            default: function () {
                return [];
            }
        },
        pagar_liq_ventas: {
            type: Boolean,
            required: false,
            default: false
        },
        valor_referido: {
            type: Number,
            required: false,
            default: 1.5
        }
    },
    methods: {
        pagar: function (row) {
            swal({
                title: "¿Desea pagar la liquidación de venta seleccionada?",
                text: "Se requiere confirmación",
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Pagar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.value) {
                    axios.post(url + '/liquidacion-ventas/' + row.id + '/pagar').then(() => {
                        swal('La liquidación fue pagada exitósamente.', 'Realizado', 'success');
                        this.consultar();
                    }).catch(({response}) => {
                        if (response.status == 409) {
                            swal('La liquidación ya ha sido pagada con anterioridad.', 'Aviso', 'warning');
                        }
                        else
                            swal('Hubo un error, intente nuevamente.', 'Error', 'error');
                    });
                }
            });
        },
        anular: function (row) {
            swal({
                title: "¿Desea anular la liquidación de ventas?",
                text: "Se requiere confirmación",
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Anular",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.value) {
                    axios.post(url + '/liquidacion-ventas/' + row.id, {
                        _method: 'DELETE'
                    }).then(() => {
                        swal('La liquidación fue anulada exitósamente.', 'Realizado', 'success');
                        this.consultar();
                    }).catch(({response}) => {
                        if (response.status == 409) {
                            swal('No se puede anular una liquidación que ya ha sido pagada.', 'Aviso', 'warning');
                        }
                        else 
                            swal('Hubo un error, intente nuevamente.', 'Error', 'error');
                    });
                }
            });
        },
        imprimir: function (row) {
            window.open(url + '/liquidacion-ventas/' + row.id + '/pdf', '_blank');
        },
        imprimirExcel: function (row) {
            window.open(url + '/liquidacion-ventas/' + row.id + '/excel', '_blank');
        },
        exportar: function () {
            this.form.tipo_consulta = 'E';
            this.$refs.roles.exportar();
        },
        consultar: function () {
            this.form.tipo_consulta = 'N';
            this.$refs.roles.loadRows();
        },
        searchVendedores: function (search, loading) {
            loading(true);
            let that = this;
            let xmlhttp = new XMLHttpRequest();
            xmlhttp.onreadystatechange = function () {
                if (
                (this.readyState == 4 && this.status == 200) ||
                this.status == 201
                ) {
                let json = JSON.parse(this.responseText);
                that.vendedores = json;
                loading(false);
                } else loading(false);
            };
            xmlhttp.open("GET", url + "/search/vendedores?search=" + search, true);
            xmlhttp.send();
        },
        inputVendedor: function () {
            if (this.selectedVendedor != null)
                this.form.vendedor_id = this.selectedVendedor.id;
            else 
                this.form.vendedor_id = '';
        },
        inputBodega: function () {
            if (this.selectedBodega != null)
                this.form.bodega_id = this.selectedBodega.id;
            else  
                this.form.bodega_id = '';
        },
        referir: function (row) 
        {
            this.selectedLiquidacionId = row.id;
            this.selectedVendedorId = row.supervisor_id;
            this.$modal.show('referirTarjetas');
        }
    },
    mounted: function () {
        this.buttons.push({
                event: 'imprimirExcel',
                icon: 'fa-file-excel-o',
                class: 'btn-success btn--text',
                tooltip: 'Imprimir Excel'
            });
        this.buttons.push({
                event: 'imprimir',
                icon: 'fa-file-pdf-o',
                class: 'btn-danger btn--text',
                tooltip: 'Imprimir PDF'
            });
        if (this.anular_liquidacion_venta)
            this.buttons.push({
                    event: 'anular',
                    icon: 'fa-trash',
                    class: 'btn-warning btn--text',
                    tooltip: 'Anular'
                });
        if (this.referir_tarjetas_liquidacion) {
            this.buttons.push({
                    event: 'referir',
                    icon: 'fa-table',
                    class: 'btn-primary btn--text',
                    tooltip: 'Referir tarjetas'
                });
        }
        if (this.pagar_liq_ventas) {
            this.buttons.push({
                    event: 'pagar',
                    icon: 'fa-money',
                    class: 'btn-secondary btn--text',
                    tooltip: 'Pagar liquidación de venta'
                });
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/nomina/ConsultaLiquidacionesVenta.vue